import firebase from "firebase/app";
import "firebase/analytics";
// import "firebase/performance";

if (typeof process.env.REACT_APP_FIREBASE_APIKEY == "undefined"
  || typeof process.env.REACT_APP_FIREBASE_PROJECTID == "undefined"
  || typeof process.env.REACT_APP_FIREBASE_MESSAGINGID == "undefined"
  || typeof process.env.REACT_APP_FIREBASE_APPID == "undefined"
  || typeof process.env.REACT_APP_FIREBASE_VAPID == "undefined"
  || typeof process.env.REACT_APP_FIREBASE_MEASUREMENTID == "undefined") {
    throw Error("API variables not found.");
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID
};

class ClusterFirebase {
  // perf: firebase.performance.Performance;
  // messaging: firebase.messaging.Messaging | false;
  firebase: firebase.app.App;
  analytics: firebase.analytics.Analytics;

  constructor() {
    // Initialize Firebase
    this.firebase = firebase.initializeApp(firebaseConfig);
    // this.perf = firebase.performance();
    this.analytics = firebase.analytics();

    // if (firebase.messaging.isSupported()) {
    //   this.messaging = firebase.messaging();
    // } else {
    //   this.messaging = false;
    // }
  }

  // initMessaging() {
  //   if (this.messaging && firebase.messaging.isSupported()) {
  //     this.messaging.usePublicVapidKey(process.env.REACT_APP_FIREBASE_VAPID!);

  //     this.messaging.onMessage((payload) => {
  //       console.log('Message received. ', payload);
  //     });

  //     // Get Instance ID token. Initially this makes a network call, once retrieved
  //     // subsequent calls to getToken will return from cache.
  //     this.messaging.getToken().then((currentToken) => {
  //       console.log(currentToken);
  //       if (currentToken) {
  //         this.sendTokenToServer(currentToken);
  //       } else {
  //         // Show permission request.
  //         console.log('No Instance ID token available. Request permission to generate one.');
  //         // Show permission UI.
  //         this.setTokenSentToServer(false);
  //       }
  //     }).catch((err) => {
  //       console.log('An error occurred while retrieving token. ', err);
  //       this.setTokenSentToServer(false);
  //     });

  //     // Callback fired if Instance ID token is updated.
  //     this.messaging.onTokenRefresh(() => {
  //       if (this.messaging) {
  //         this.messaging.getToken().then((refreshedToken) => {
  //           console.log('Token refreshed.');
  //           // Indicate that the new Instance ID token has not yet been sent to the
  //           // app server.
  //           this.setTokenSentToServer(false);
  //           // Send Instance ID token to app server.
  //           this.sendTokenToServer(refreshedToken);
  //           // ...
  //         }).catch((err) => {
  //           console.log('Unable to retrieve refreshed token ', err);
  //         });
  //       }
  //     });
  //   }
  // }

  // Send the Instance ID token your application server, so that it can:
  // - send messages back to this app
  // - subscribe/unsubscribe the token from topics
  sendTokenToServer(currentToken: string) {
    if (!this.isTokenSentToServer()) {
      console.log('Sending token to server...');
      // TODO(developer): Send the current token to your server.
      this.setTokenSentToServer(true);
    } else {
      console.log('Token already sent to server so won\'t send it again ' +
          'unless it changes');
    }

  }

  isTokenSentToServer() {
    return window.localStorage.getItem('sentToServer') === '1';
  }

  setTokenSentToServer(sent: boolean) {
    window.localStorage.setItem('sentToServer', sent ? '1' : '0');
  }

}

export default new ClusterFirebase();